export default [
  {
    question: "Frequently Asked Questions",
    answer: "<ol>" +
        "<li><strong>What does Certified Super mean?</strong><br/>" +
        "Certified Super is a label given to outlets that we recommend for their popularity and good value. </li>" +
        "<li><strong>Where can I find Certified Super outlets?</strong><br/>" +
        "Currently, you can find it on airasia Food and airasia Hotels in the airasia Super App and website.</li>" +
        "<li><strong>Can I apply for our outlet to be Certified Super?</strong><br/>" +
        "No, the Certified Super title is conferred only to merchants who meet the criteria. Stay tuned for any updates on the programme.</li>" +
        "<li><strong>How do merchants get the Certified Super badge?</strong><br/>" +
        "The Certified Super designation is given by airasia voluntarily and will be updated on a yearly basis. Merchants do not need to opt in.</li>" +
        "<li><strong>Are there other benefits for choosing Certified Super outlets?</strong><br/>" +
         "At the moment, it serves as a recommendation. There are no deals or promotions associated with Certified Super unless deals or promotions are clearly labelled.</li>" +
         "<li><strong>Do I get more BIG Points for purchases from Certified Super outlets?</strong><br/>" +
         "The standard BIG Points multiplier applies to purchases from Certified Super outlets, unless otherwise stated.</li>" +
        "</ol>"
  },
]
